const classNames = {
  disableScroll: "dsf-disable-scroll"
};
export {
  classNames
};
